import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AsteriskModule } from '@salesrun/ngx-asterisk';
import { NoAutocompleteModule } from '@salesrun/ngx-no-autocomplete';
import { PasswordSetupComponent } from './password-setup.component';

@NgModule({
    imports: [
        //external
        CommonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,

        //
        AsteriskModule,
        NoAutocompleteModule,
    ],
    declarations: [
        PasswordSetupComponent,
    ],
    exports: [
        PasswordSetupComponent,
    ],
})
export class PasswordSetupModule { }